import React from "react";

const ToggleButton = ({ label, onChange, value, className = "" }) => {
  return (
    <div className={className}>
      <div className="flex items-center gap-2">
        <div className="font-medium">{label}</div>
        <label class="relative inline-flex items-center cursor-pointer">
          <input
            onChange={(e) => onChange(e.target.checked)}
            checked={value}
            type="checkbox"
            value=""
            class="sr-only peer"
          />
          <div class="w-9 h-5 bg-gray-200 hover:bg-gray-300 peer-focus:outline-0 peer-focus:ring-transparent rounded-full peer transition-all ease-in-out duration-500 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary hover:peer-checked:bg-primary"></div>
        </label>
      </div>
    </div>
  );
};

export default ToggleButton;
